import axios from "axios";
import { getVoiceApi } from "./config.service";

export const getToken = () => {
    if (localStorage.getItem('TOKEN')) {

        return {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('TOKEN')
            }
        }
    }

    return {};
}



const apiService = axios.create({
    baseURL: getVoiceApi(),
    //withCredentials: true,
    timeout: 30000,
    ...getToken(),
});

apiService.interceptors.response.use(response => {
    return response;
}, error => {
    if (error?.response?.data?.data?.messages?.some((m: string) => m.toLowerCase().indexOf("user is not authenticated") !== -1)) {
        document.location.href = "/login";
    }
    return Promise.reject(error);
});

export default apiService;

export const secretApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/', '/library-item-secret-variables/'),
    //withCredentials: true,
    timeout: 30000,
    ...getToken(),
});



export const UserApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/', '/user/'),
    timeout: 30000,
    ...getToken(),
});

export const JiraApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/', '/jira/'),
    timeout: 30000,
    ...getToken(),
});

export const ExportApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/v1', '/v1/'),
    timeout: 30000,
    ...getToken(),
});

// Add folderApi to use /api instead of /api/voice/v1 for folders
export const folderApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/v1', ''),
    timeout: 30000,
    ...getToken(),
});


export const ssoApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/v1', ''),
    timeout: 30000,
});


export const lensApi = axios.create({
    baseURL: (process.env.BACKEND_URL) ? process.env.BACKEND_URL : 'https://api.tekvision.com',
    timeout: 30000,
});


export const appConfigApi = axios.create({
    baseURL: getVoiceApi()?.replace('/voice/', '/config/'),
    timeout: 30000,
    ...getToken(),
});